import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Divider, FlexBox, Text } from '@dixa/lib-shared-habla';
import { colors } from '@dixa/lib-shared-tokens';
import { memo } from 'react';
import { CopilotSelectionList } from './components';
/**
 * Represents the root component of the Copilot dropdown that will render the
 * list of actual actions.
 */
export const CopilotDropdownRoot = memo(function CopilotDropdownRoot({ onSelectionChange, }) {
    return (_jsxs(FlexBox, Object.assign({ flexDirection: "column", style: { width: 400 } }, { children: [_jsx(Box, Object.assign({ padding: "200 300" }, { children: _jsx(Text.Heading, Object.assign({ variant: "heading-2", color: colors.purple['600'] }, { children: "AI features powered by Dixa" })) })), _jsx(Divider, {}), _jsx(CopilotSelectionList, { onChange: onSelectionChange })] })));
});
